import Base from "@/controllers/base";
export default class Trucker extends Base {
  constructor(elem) {
    super(elem);
  }

  async toggleTasks(event) {
    const input = event.target;
    const fd = new FormData();
    fd.set("authenticity_token", this.authenticityToken);
    fd.set("type", input.name.replace(/\[\]/g, ""));
    [...input.selectedOptions]
      .map((e) => e.value)
      .forEach((value) => {
        fd.append("tasks[]", value);
      });

    const response = await fetch(`/truckers/${input.id}/tasks.json`, {
      method: "PATCH",
      body: fd,
    });

    const result = await response.json();
    const el = document.getElementById(result.id);
    ["add", "remove"].forEach((x) => el.classList[x](result[x]));
  }
}
